"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = delay;

function delay(ms, output) {
  return new Promise((resolve, reject) => setTimeout(() => {
    if (output instanceof Error) {
      reject(output);
    } else {
      resolve(output);
    }
  }, ms));
}

module.exports = exports["default"];